import { ValueType } from 'realgrid'

export const ordMstFields = [
    { fieldName: 'ownerKey', dataType: ValueType.TEXT },
    { fieldName: 'ordNo', dataType: ValueType.TEXT },
    { fieldName: 'disOrdNo', dataType: ValueType.TEXT },
    { fieldName: 'custCd', dataType: ValueType.TEXT },
    { fieldName: 'custNm', dataType: ValueType.TEXT },
    { fieldName: 'deptCd', dataType: ValueType.TEXT },
    { fieldName: 'deptNm', dataType: ValueType.TEXT },
    { fieldName: 'ordDt', dataType: "datetime", datetimeFormat: "yyyyMMdd" },
    { fieldName: 'ordCd', dataType: ValueType.TEXT },
    { fieldName: 'ordCdNm', dataType: ValueType.TEXT },
    { fieldName: 'divCd', dataType: ValueType.TEXT },
    { fieldName: 'divCdNm', dataType: ValueType.TEXT },
    { fieldName: 'resCd', dataType: ValueType.TEXT },
    { fieldName: 'resCdNm', dataType: ValueType.TEXT },
    { fieldName: 'status', dataType: ValueType.TEXT },
    { fieldName: 'recYn', dataType: ValueType.TEXT },
    { fieldName: 'proStcYn', dataType: ValueType.TEXT },
    { fieldName: 'confirmYn', dataType: ValueType.TEXT },
    { fieldName: 'ifConfirmYn', dataType: ValueType.TEXT },
    { fieldName: 'useYn', dataType: ValueType.TEXT },
    { fieldName: 'backOrdNo', dataType: ValueType.TEXT },
    { fieldName: 'userNm', dataType: ValueType.TEXT },
    { fieldName: 'userId', dataType: ValueType.TEXT },
    { fieldName: 'insertDt', dataType: ValueType.TEXT }
]

export const ordMstColumns = [
    {
        name: 'ownerKey',
        fieldName: 'ownerKey',
        type: 'data',
        width: '50',
        styleName: "rg-align-center",
        header: {
            text: '화주코드',
            showTooltip: false
        },
        visible: false
    },
    {
        name: 'ordNo',
        fieldName: 'ordNo',
        type: 'data',
        width: '80',
        styleName: "rg-align-center",
        header: '원주문번호',
        visible: false
    },
    {
        name: 'ordDt',
        fieldName: 'ordDt',
        type: 'data',
        width: '100',
        styleName: "rg-align-left",
        datetimeFormat: "yyyy-MM-dd",
        header: '주문일자',
    },
    {
        name: 'disOrdNo',
        fieldName: 'disOrdNo',
        type: 'data',
        width: '100',
        styleName: "rg-align-center",
        header: '주문번호',
    },
    {
        name: 'custCd',
        fieldName: 'custCd',
        type: 'data',
        width: '100',
        styleName: "rg-align-center",
        header: {
            text: '거래처코드',
            showTooltip: false
        }
    },
    {
        name: 'custNm',
        fieldName: 'custNm',
        type: 'data',
        width: '200',
        styleName: "rg-align-left",
        header: {
            text: '거래처명',
            showTooltip: false
        }
    },
    {
        name: 'deptCd',
        fieldName: 'deptCd',
        type: 'data',
        width: '50',
        styleName: "rg-align-center",
        header: {
            text: '부과코드',
            showTooltip: false
        },
        visible: false
    },    
    {
        name: 'deptNm',
        fieldName: 'deptNm',
        type: 'data',
        width: '150',
        styleName: "rg-align-left",
        header: {
            text: '부과명',
            showTooltip: false
        }
    },  
    {
        name: 'ordCd',
        fieldName: 'ordCd',
        type: 'data',
        width: '50',
        styleName: "rg-align-left",
        header: {
            text: '주문구분코드',
            showTooltip: false
        },
        visible: false
    },
    {
        name: 'ordCdNm',
        fieldName: 'ordCdNm',
        type: 'data',
        width: '100',
        styleName: "rg-align-left",
        header: {
            text: '주문구분',
            showTooltip: false
        }
    },
    {
        name: 'divCd',
        fieldName: 'divCd',
        type: 'data',
        width: '50',
        styleName: "rg-align-left",
        header: {
            text: '배송구분코드',
            showTooltip: false
        },
        visible: false
    },
    {
        name: 'divCdNm',
        fieldName: 'divCdNm',
        type: 'data',
        width: '100',
        styleName: "rg-align-left",
        header: {
            text: '배송구분',
            showTooltip: false
        }
    },
    {
        name: 'resCd',
        fieldName: 'resCd',
        type: 'data',
        width: '50',
        styleName: "rg-align-left",
        header: {
            text: '사유코드',
            showTooltip: false
        },
        visible: false
    },
    {
        name: 'resCdNm',
        fieldName: 'resCdNm',
        type: 'data',
        width: '100',
        styleName: "rg-align-left",
        header: {
            text: '사유',
            showTooltip: false
        }
    },
    {
        name: 'status',
        fieldName: 'status',
        type: 'data',
        width: '100',
        styleName: "rg-align-left",
        header: {
            text: '주문현황',
            showTooltip: false
        }
    },
    {
        name: 'userId',
        fieldName: 'userId',
        type: 'data',
        width: '120',
        styleName: "rg-align-left",
        header: {
            text: '사용자명',
            showTooltip: false
        }
    },
    {
        name: 'insertDt',
        fieldName: 'insertDt',
        type: 'data',
        width: '120',
        styleName: "rg-align-left",
        header: {
            text: '등록일',
            showTooltip: false
        }
    }
]

export const ordDtlFields = [
    //마스터데이터
    { fieldName: 'ordDt', dataType: ValueType.TEXT },
    { fieldName: 'disOrdNo', dataType: ValueType.TEXT },
    { fieldName: 'custCd', dataType: ValueType.TEXT },
    { fieldName: 'custNm', dataType: ValueType.TEXT },
    { fieldName: 'deptNm', dataType: ValueType.TEXT },
    { fieldName: 'ordCdNm', dataType: ValueType.TEXT },
    { fieldName: 'divCdNm', dataType: ValueType.TEXT },
    { fieldName: 'resCdNm', dataType: ValueType.TEXT },
    { fieldName: 'status', dataType: ValueType.TEXT },

    //디테일데이터
    { fieldName: 'itemSeq', dataType: ValueType.NUMBER },
    { fieldName: 'ordNo', dataType: ValueType.TEXT },
    { fieldName: 'itemCd', dataType: ValueType.TEXT },
    { fieldName: 'itemNm', dataType: ValueType.TEXT },
    { fieldName: 'avaQty', dataType: ValueType.NUMBER },
    { fieldName: 'ordQty', dataType: ValueType.NUMBER },
    { fieldName: 'remark', dataType: ValueType.TEXT }
]

export const ordDtlColumns = [
    {
        name: 'ordDt',
        fieldName: 'ordDt',
        type: 'data',
        width: '100',
        styleName: "rg-align-left",
        header: '주문일자',
        visible: false
    },
    {
        name: 'disOrdNo',
        fieldName: 'disOrdNo',
        type: 'data',
        width: '100',
        styleName: "rg-align-center",
        header: '주문번호',
        visible: false
    },
    {
        name: 'custCd',
        fieldName: 'custCd',
        type: 'data',
        width: '100',
        styleName: "rg-align-center",
        header: {
            text: '거래처코드',
            showTooltip: false
        },
        visible: false
    },
    {
        name: 'custNm',
        fieldName: 'custNm',
        type: 'data',
        width: '200',
        styleName: "rg-align-left",
        header: {
            text: '거래처명',
            showTooltip: false
        },
        visible: false
    },
	{
        name: 'deptNm',
        fieldName: 'deptNm',
        type: 'data',
        width: '150',
        styleName: "rg-align-left",
        header: {
            text: '부과명',
            showTooltip: false
        },
        visible: false
    }, 
	{
        name: 'ordCdNm',
        fieldName: 'ordCdNm',
        type: 'data',
        width: '100',
        styleName: "rg-align-left",
        header: {
            text: '주문구분',
            showTooltip: false
        },
        visible: false
    },	
	{
        name: 'divCdNm',
        fieldName: 'divCdNm',
        type: 'data',
        width: '100',
        styleName: "rg-align-left",
        header: {
            text: '배송구분',
            showTooltip: false
        },
        visible: false
	},
	{
        name: 'resCdNm',
        fieldName: 'resCdNm',
        type: 'data',
        width: '100',
        styleName: "rg-align-left",
        header: {
            text: '사유',
            showTooltip: false
        },
        visible: false
    },
    {
        name: 'status',
        fieldName: 'status',
        type: 'data',
        width: '100',
        styleName: "rg-align-left",
        header: {
            text: '주문현황',
            showTooltip: false
        },
        visible: false
    },
    //엑셀을 위한 마스터 데이터 추가
    {
        name: 'itemSeq',
        fieldName: 'itemSeq',
        type: 'data',
        width: '50',
        styleName: "rg-align-center",
        header: {
            text: '제품순번',
            showTooltip: false
        },
        visible: false
    },
    {
        name: 'ordNo',
        fieldName: 'ordNo',
        type: 'data',
        width: '80',
        styleName: "rg-align-center",
        header: '원주문번호',
        visible: false
    },
    {
        name: 'itemCd',
        fieldName: 'itemCd',
        type: 'data',
        width: '120',
        styleName: "rg-align-left",
        header: '제품코드',
    },
    {
        name: 'itemNm',
        fieldName: 'itemNm',
        type: 'data',
        width: '200',
        styleName: "rg-align-left",
        header: '제품',
    },
    {
        name: 'avaQty',
        fieldName: 'avaQty',
        type: 'data',
        width: '50',
        numberFormat: "#,##0.#",
        styleName: "rg-align-right",
        header: {
            text: '주문가능수량',
            showTooltip: false
        },
        visible: false
    },
    {
        name: 'avaYn',
        fieldName: 'avaYn',
        type: 'data',
        width: '80',
        styleName: "rg-align-left",
        header: '재고보유여부',
        visible: false
    },
    {
        name: 'ordQty',
        fieldName: 'ordQty',
        type: 'data',
        width: '80',
        numberFormat: "#,##0.#",
        styleName: "rg-align-right",
        header: {
            text: '주문수량',
            showTooltip: false
        }
    },
    {
        name: 'remark',
        fieldName: 'remark',
        type: 'data',
        width: '160',
        styleName: "rg-align-left",
        header: '비고',
    }
]
